import { useState } from 'react';
import { getApiBaseURL } from '../services/api';

/**
 * Хук для обработки виртуальной примерки
 */
export const useTryOn = (apiKey, apiUrl) => {
  const [isProcessing, setIsProcessing] = useState(false);
  const [resultImages, setResultImages] = useState([]);
  const [error, setError] = useState(null);

  const getHeaders = () => {
    const headers = {};
    if (apiKey) {
      headers['X-API-Key'] = apiKey;
    }
    return headers;
  };

  const startTryOn = async (selectedCloth, personImage) => {
    if (!selectedCloth || !personImage) {
      setError('Пожалуйста, выберите одежду и загрузите свое фото');
      return;
    }

    setIsProcessing(true);
    setError(null);
    setResultImages([]);

    try {
      const formData = new FormData();
      formData.append('clothes_id', selectedCloth._id);
      formData.append('person_image', personImage);

      const apiBaseURL = getApiBaseURL(apiUrl);
      const headers = getHeaders();
      
      const response = await fetch(`${apiBaseURL}/api/v1/virtual-try-on/open-router`, {
        method: 'POST',
        headers: headers,
        body: formData
      });

      if (!response.ok) {
        const errorText = await response.text();
        setError(`Ошибка сервера: ${response.status} - ${errorText}`);
        setIsProcessing(false);
        return;
      }

      const contentType = response.headers.get('content-type') || '';
      
      if (contentType.includes('text/event-stream')) {
        const reader = response.body.getReader();
        const decoder = new TextDecoder();

        const processStream = async () => {
          try {
            while (true) {
              const { done, value } = await reader.read();
              
              if (done) {
                break;
              }

              const chunk = decoder.decode(value, { stream: true });
              const lines = chunk.split('\n');

              for (const line of lines) {
                if (line.trim() === '') continue;
                
                if (line.startsWith('data: ')) {
                  const data = line.slice(6);
                  
                  if (data === '[DONE]') {
                    break;
                  }

                  try {
                    const parsedData = JSON.parse(data);
                    
                    if (parsedData.error) {
                      setError(parsedData.error);
                      setIsProcessing(false);
                      return;
                    }
                    
                    if (parsedData.images) {
                      setResultImages(parsedData.images);
                      setIsProcessing(false);
                      return;
                    }
                  } catch (e) {
                    console.error('Ошибка парсинга SSE данных:', e);
                  }
                }
              }
            }
          } catch (error) {
            console.error('Ошибка при чтении SSE потока:', error);
            setError('Ошибка соединения с сервером');
            setIsProcessing(false);
          }
        };

        processStream();
      } else {
        try {
          const data = await response.json();
          console.log('Получен ответ от сервера:', data);
          
          let images = [];
          
          if (data.result_images_urls && Array.isArray(data.result_images_urls)) {
            images = data.result_images_urls;
          } else if (data.images && Array.isArray(data.images)) {
            images = data.images;
          } else if (data.body && data.body.result_images_urls && Array.isArray(data.body.result_images_urls)) {
            images = data.body.result_images_urls;
          }
          
          if (images.length > 0) {
            setResultImages(images);
          } else {
            setError('Результат не содержит изображений');
          }
          
          setIsProcessing(false);
        } catch (error) {
          console.error('Ошибка парсинга JSON ответа:', error);
          setError('Ошибка при обработке ответа сервера');
          setIsProcessing(false);
        }
      }

    } catch (error) {
      console.error('Ошибка виртуальной примерки:', error);
      setError('Произошла ошибка при обработке запроса');
      setIsProcessing(false);
    }
  };

  return {
    isProcessing,
    resultImages,
    error,
    startTryOn,
    setError
  };
};

